import logo from 'assets/images/ktech.png';

const LogoMain = () => {
  return <img src={logo} alt="Ktech" width="200" />;
};

export default LogoMain;
